import React from 'react'
import Link from 'next/link'
import moment from "moment"
import {ASSET_URL} from "../../../../../config";
import dayjs from "dayjs";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {Space} from "antd";
import {LinkOutlined} from "@ant-design/icons";
import {applyLang} from "../../../../../i18n";

const EventSection2 = (props) => {

    const {org,lang}=props.context

    return(
        <div className={`wpo-event-area section-padding  ${props.EventClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <span><Trans>Nos Événements</Trans></span>
                            <h2><Trans>Nos événements à venir</Trans></h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {props.events.map( (item, i) => {
                        const datemoment=dayjs(item.dateEvent)
                        const isMulti=!!item.isMultiSession
                        let image=item.image || null
                        if(image && !image.startsWith("http")){
                            image=ASSET_URL+item.image
                        }
                        return(
                            <div className="col-lg-6 col-sm-12 col-12 custom-grid" key={i}>
                                <div className="wpo-event-item">

                                    <Link href={org.BASE_WEB_URL + "/evenement/" + item.id}>
                                        <div className="wpo-event-img" style={{cursor:'pointer'}}>
                                            {image ? (
                                                <img src={image} alt="" style={{objectFit: "cover", height: 300}}/>
                                            ) : (
                                                <div style={{height: 300, background: "linear-gradient(135deg, #1e293b, #475569)", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:"3rem", fontWeight:800, opacity:0.85}}>
                                                    {(item.name || "?").charAt(0).toUpperCase()}
                                                </div>
                                            )}
                                            {!isMulti && (
                                                <div className="thumb-text">
                                                    <span>{datemoment.date()}</span>
                                                    <span>{datemoment.format("MMM").toUpperCase().replace(".", "")}</span>
                                                </div>
                                            )}
                                        </div>
                                    </Link>

                                    <div className="wpo-event-text" style={{height:300}}>
                                        <div style={{height:"100%",display:"flex",flexDirection:"column",justifyContent:"space-between"}}>

                                            <div>
                                                <Link href={org.BASE_WEB_URL + "/evenement/" + item.id}><h2 style={{cursor:"pointer"}}>{item.name}</h2></Link>
                                                <ul>
                                                    {isMulti ? (
                                                        <li><i className="fa fa-calendar" aria-hidden="true"></i> <Trans>Plusieurs sessions disponibles</Trans></li>
                                                    ) : (
                                                        <>
                                                            <li><i className="fa fa-clock-o" aria-hidden="true"></i>{dayjs(item.dateEvent).format("LT")}</li>
                                                            {item.adresse && <li><i className="fa fa-map-marker"></i>{item.adresse}</li>}
                                                        </>
                                                    )}
                                                </ul>

                                                {!isMulti && (item.links || []).length>0 && (
                                                    <div style={{marginTop:20}}>
                                                        <Space size="large">
                                                            {(item.links || []).map(i=>{
                                                                const tLink=applyLang(i,lang)
                                                                return (
                                                                    <a href={tLink.url} target="_blank" style={{cursor:"pointer"}}><LinkOutlined /> {tLink.name}</a>
                                                                )
                                                            })}
                                                        </Space>
                                                    </div>
                                                )}
                                            </div>


                                            <div style={{display:"flex",justifyContent:"flex-end",alignItems:"flex-end"}}>
                                                <Link href={org.BASE_WEB_URL + "/evenement/" + item.id}>{t`Voir Plus...`}</Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    })}
                </div>
            </div>
        </div>
    )
}

export default EventSection2;
